import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Invoice} from "../../../models/invoice";
import {StatusFinanceiroIntegration} from "../../../models/enums/invoice/status-financeiro-integration";
import {InvoiceUpdateProgramadoComponent} from "../../../pages/billing/invoice/invoice-update-programado/invoice-update-programado.component";
import {DialogService} from "primeng/dynamicdialog";

/**
 * EM-2702/EM-2910: estado da integração da fatura com o financeiro (ERP), coluna "Financeiro" da lista de faturas.
 * Em ERROR o ícone abre o diálogo que mostra o erro da fila e reenvia a fatura (update-programado).
 */
@Component({
  selector: 'app-financeiro-icon',
  templateUrl: './financeiro-icon.component.html',
  styleUrls: ['./financeiro-icon.component.scss']
})
export class FinanceiroIconComponent {

  @Input() invoice!: Invoice;
  @Output() updateTable = new EventEmitter();
  protected readonly StatusFinanceiroIntegration = StatusFinanceiroIntegration;

  constructor(private dialog: DialogService) {}

  async updateInvoice(): Promise<void> {
    const invoice = this.invoice;
    this.dialog.open(InvoiceUpdateProgramadoComponent, {
      width: '45%',
      height: 'auto',
      header: 'Fatura ' + this.invoice.invoiceNumber,
      data: { invoice }
    }).onClose.subscribe(() => {
      this.updateTable.emit()
    });
  }
}
